const firebaseConfig = {
    apiKey: "AIzaSyAtzpYwC_lMhY8MeI4D9VaQzZFx83a00As",
    authDomain: "finding-paradise.firebaseapp.com",
    projectId: "finding-paradise",
    storageBucket: "finding-paradise.appspot.com",
    messagingSenderId: "758368209184",
    appId: "1:758368209184:web:46cbde900d945937d1af45"
  };
  export default firebaseConfig;